import { Component, OnInit } from '@angular/core';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { ConfirmationModalComponent } from 'libs/portal/src/modules/home/components/user/components/confirmation-modal/confirmation-modal.component';
import { Endpoints } from '@huge-monorepo/portal/config';
import { MemoryService } from 'libs/portal/src/services/memory/memory.service';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ICustomerGenericService, IHIPGenericService } from '@huge-monorepo/shared/interfaces';
import { SharedGenericSingletonService } from '@huge-monorepo/shared/services';

@Component({
  selector: 'app-settings-menu',
  templateUrl: './settings-menu.component.html',
  styleUrls: ['./settings-menu.component.scss'],
})
export class SettingsMenuComponent implements OnInit {
  isLightMode = this.sharedGenericService.getIsLightMode();
  path = this.sharedGenericService.getPath(!this.isLightMode);
  ScreenSize = ScreenSize;
  groupAdmin = false;
  obfuscate = false;
  preferedGraphValue: string;
  modalStyle: string = this.layoutService.screenSize > this.ScreenSize.MOBILE_L ? 'auto-height' : '';

  constructor(
    private auth: UserRightsService,
    private layoutService: LayoutService,
    private endpoints: Endpoints,
    private memoryService: MemoryService,
    private genericService: GenericService,
    private toastService: ToastrService,
    private dialogRef: MatDialogRef<SettingsMenuComponent>,
    private sharedGenericService: SharedGenericSingletonService< ICustomerGenericService | IHIPGenericService >,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.groupAdmin = this.auth.IsGroupAdmin();
    this.obfuscate = this.auth.GetUser().value.isObfuscated;
    this.preferedGraphValue = this.memoryService.getLocalPreferences().value.preferedGraphUnit;
  }

  logout() {
    this.openConfirmationModal();
  }

  obfuscateClientDetailsToggled(): void {
    this.obfuscate = !this.obfuscate;
    this.auth.SetObfuscation(this.obfuscate);
  }

  changeGraphDataUnit(data: any): void {
    this.memoryService.setPreferedGraphUnit(data.detail.value);
  }

  async dismissOverlay() {
    this.dialogRef.close();
  }


  openEndpointFile(): void {
    this.genericService.GET(this.endpoints.GET_ENDPOINTS_COLLECTION_DOCUMENT).subscribe({
      next: (res) => {
            var content = res["body"];
            const byteCharacters = atob(content);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "text/html" });
            const url = URL.createObjectURL(blob);
            this.dismissOverlay();
            window.open(url, '_blank');

            URL.revokeObjectURL(url);

      }
    });
  }

  async openConfirmationModal() {
    const dialogRefI = this.dialog.open(ConfirmationModalComponent, {
      data: {
        confimationMessage: 'Are you sure that you would like to logout?',
      },
      panelClass: this.modalStyle,
    });

    let dialogSub = dialogRefI.afterClosed().subscribe({
      next: (dataReturned) => {
        if (dataReturned) {
          this.genericService.GET(this.endpoints.LOGOUT).subscribe(
            (res) => {
              this.auth.Logout();
              this.toastService.success('', (res as any).body, { timeOut: 2000 });
            },
            () => {
              this.auth.Logout();
            },
          );
        }
        this.dismissOverlay();
        dialogSub.unsubscribe();
      },
    });
  }
}
